// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { QUICKSTART_UI_STATUS, getBackendVisibilityKey } from '../../../common/constants.tsx';
import { pushToBackend } from '../../../common/utils/pushToBackend.tsx';
import type { State } from '../../model/types.tsx';
import { getQuickstartTypeSelector } from '../../model/utils.tsx';
import { setLocalStorageItem } from '../../utils.tsx';

export const nextSetChecklistIsDismissed =
	(isDismissed: boolean): Action<State> =>
	async ({ getState, setState }) => {
		const state = getState();
		const quickstartType = getQuickstartTypeSelector(state);
		const currentIsDismissed = state.visibility[quickstartType] === QUICKSTART_UI_STATUS.DISMISSED;
		if (isDismissed === currentIsDismissed) {
			// if state has not been updated we just return
			return;
		}

		const quickstartStatus = isDismissed
			? QUICKSTART_UI_STATUS.DISMISSED
			: QUICKSTART_UI_STATUS.OPEN;

		await pushToBackend({
			key: getBackendVisibilityKey(quickstartType),
			value: quickstartStatus,
		});

		setState({
			visibility: {
				...state.visibility,
				[quickstartType]: quickstartStatus,
			},
			isFocusedOn: !isDismissed,
		});
		setLocalStorageItem(`${quickstartType}.visibility`, quickstartStatus);
	};
